module.exports = __webpack_public_path__ + "img/stamp.a07c7601.svg";